import index from "./goPayment.vue";
export default index;
